<svg-icon class="mb-4" key="px-96-success" size="4xl" />
<h3 class="typo-h1 mb-2 text-center text-text-primary">{{ 'perio_exam_done_title' | translate }}</h3>
<p class="typo-h4-light text-center text-text-primary">{{ 'perio_exam_done_subtitle' | translate }}</p>
